// Hands a grid page's in-memory state to crew-activity-mobile and back, without ever
// putting it through history.pushState — the browser enforces a real size limit there
// (roughly 640KB-2MB depending on browser) and large grid datasets (e.g. crew activity's
// full schedule) can silently exceed it, causing history.push to throw and the
// navigation to appear to do nothing. This is a plain module-level singleton — fine
// since it only needs to survive for the lifetime of the SPA session, not a reload.
let cache = null;

export const stashGridState = (state) => {
  cache = state;
};

/** Reads and clears the cache in one step, so a stale value can't leak into an unrelated later visit. */
export const popGridState = () => {
  const state = cache;
  cache = null;
  return state;
};
